var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trigger mt-5"},[(_vm.triggerModel)?_c('trigger-setup',{attrs:{"disabled":!_vm.canChangeConfig,"controls":{
      'view': _vm.TriggerControls,
      'props': {
        disabled: !_vm.canChangeConfig,
      },
      'listeners': _vm.controlsListeners
    }},on:{"on-validation-change":function($event){_vm.isTriggerValid = $event}},model:{value:(_vm.triggerModel),callback:function ($$v) {_vm.triggerModel=$$v},expression:"triggerModel"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }